
const TemplateEleven = () => {
    return (
      <div className="slideshow">
        <figure>
          {/* Project Details Starts */}
          <figcaption>
            <h3>HTML Template</h3>
            <div className="row open-sans-font">
              <div className="col-12 mb-2">
                <i class="fab fa-html5"></i>
                <span className="ft-wt-600 uppercase"> Creative with minimal and modern design. If you are looking for a Trendy Spa Salon kinda Website AQUA in the best fit for you.</span>
              </div>
            </div>
            {/* End .row */}
          </figcaption>
          {/* Project Details Ends */}
  
          {/*  Main Project Content Starts */}
          <img src="img/projects/templates/11.jpg" alt="Portolio" />
          {/* Main Project Content Ends */}
        </figure>
      </div>
      //  End .slideshow
    );
  };
  
  export default TemplateEleven;
  